<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#vitamine2plus">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Vitamine și minerale</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span></div>
    </div>

    <div id="vitamine2plus" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina A</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">503 µg-RE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">74 µg-RE</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina D</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">16 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">2.39 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina C</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">100 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">15 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Riboflavină B2</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.98 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.14 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B12</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.7 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.25 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Calciu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">882 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">130 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fier</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">9.3 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.4 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Iod</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">106 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">16 µg</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vitamine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
